/* tslint:disable */

/**
 */
export class RpTimeKeepingForm {
    from_date?: string;
    to_date?: string;
}
